export default __webpack_public_path__ + "a4cef26f3815e77eed837b16d28ceb11.png";